const RequiredFieldLabel = ({label, hide}: {label: string; hide?: boolean}) => (
  <>
    {label}
    {!hide && <span style={{color: 'red'}}>*</span>}
  </>
)

export default RequiredFieldLabel
